module.exports = __webpack_public_path__ + "static/media/pryde-4h-logos.c6d1b1e4.png";